var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#94a3b8",
    stroke: "#94a3b8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sun",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 23
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 4.22,
    x2: 5.64,
    y2: 5.64
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 18.36,
    x2: 19.78,
    y2: 19.78
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 12,
    x2: 3,
    y2: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 23,
    y2: 12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 19.78,
    x2: 5.64,
    y2: 18.36
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 5.64,
    x2: 19.78,
    y2: 4.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b75d9ae1f8dafcf0365aa12aeb1e0362.svg";
export { ForwardRef as ReactComponent };